import { render } from "./ProjectContentComponent.vue?vue&type=template&id=25ac88f0&scoped=true"
import script from "./ProjectContentComponent.vue?vue&type=script&lang=js"
export * from "./ProjectContentComponent.vue?vue&type=script&lang=js"

import "./ProjectContentComponent.vue?vue&type=style&index=0&id=25ac88f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ac88f0"]])

export default __exports__